(function($) {

	$(document).ready(function() {
		$('a[href^="#"]').on('click', function(event) {
			event.preventDefault();
			var target = $($.attr(this, 'href'));
			if (target.length) {
				$('html, body').animate({
					scrollTop: target.offset().top
				}, 800); 
			}
		});
	});

	$('.faq .define .question').click(function() {
		$(this).next().slideToggle();
		$(this).toggleClass('is-open');
	});

	$(function() {
		var fvHeight = $('.fv').outerHeight();
		var bannerHeight = $('.scroll').outerHeight();

		$(window).on('scroll', function() {
			var scrollBottom = $(this).scrollTop() + $(this).height();
			if (scrollBottom >= fvHeight + bannerHeight) {
				$('.scroll').addClass('is-show');
			} else {
				$('.scroll').removeClass('is-show');
			}
		});
	});


})(jQuery);
